import React from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { AuthProvider, useAuth } from './auth/AuthContext';
import AppShell from './layout/AppShell';
import Analytics from './pages/Analytics';
import ChangePassword from './pages/ChangePassword';
import Login from './pages/Login';
import Directory from './pages/Directory';
import Onboardings from './pages/Onboardings';
import Placements from './pages/Placements';
import Recruitment from './pages/Recruitment';
import Reports from './pages/Reports';
import Users from './pages/Users';
import { Alert, Spinner } from './ui/basics';
import { ToastProvider } from './ui/overlay';

const HOME_ORDER = [['recruitment', '/recruitment'], ['placements', '/placements'], ['reports', '/reports'], ['analytics', '/analytics'], ['directory', '/directory'], ['onboardings', '/onboardings'], ['users', '/users']];

function Protected({ children }) {
  const { user, booting } = useAuth();
  if (booting) return <div style={{ height: '100%', display: 'grid', placeItems: 'center' }}><Spinner /></div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function Page({ page, children }) {
  const { hasPage, orgs } = useAuth();
  if (!hasPage(page)) return <Alert>You do not have access to this page.</Alert>;
  if (page !== 'users' && orgs.length === 0) return <Alert>No organization is assigned to your account. Ask an administrator for access.</Alert>;
  return children;
}

function Home() {
  const { hasPage, user } = useAuth();
  if (user.must_change_password) return <Navigate to="/change-password" replace />;
  const target = HOME_ORDER.find(([page]) => hasPage(page));
  return target ? <Navigate to={target[1]} replace /> : <Alert>Your account has no pages assigned. Ask an administrator for access.</Alert>;
}

function Forced({ children }) {
  const { user } = useAuth();
  return user.must_change_password ? <Navigate to="/change-password" replace /> : children;
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <ToastProvider>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route element={<Protected><AppShell /></Protected>}>
              <Route index element={<Home />} />
              <Route path="/change-password" element={<ChangePassword />} />
              <Route path="/recruitment" element={<Forced><Page page="recruitment"><Recruitment /></Page></Forced>} />
              <Route path="/placements" element={<Forced><Page page="placements"><Placements /></Page></Forced>} />
              <Route path="/reports" element={<Forced><Page page="reports"><Reports /></Page></Forced>} />
              <Route path="/analytics" element={<Forced><Page page="analytics"><Analytics /></Page></Forced>} />
              <Route path="/directory" element={<Forced><Page page="directory"><Directory /></Page></Forced>} />
              <Route path="/onboardings" element={<Forced><Page page="onboardings"><Onboardings /></Page></Forced>} />
              <Route path="/users" element={<Forced><Page page="users"><Users /></Page></Forced>} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Route>
          </Routes>
        </ToastProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}
